(() => {
  if (window.MayLondonV19) return;
  window.MayLondonV19 = true;
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  function init(scope = document) {
    scope.querySelectorAll('[data-mobile-menu]').forEach(dialog => {
      if (controllers.has(dialog)) return;
      const controller = new AbortController(), opts = { signal: controller.signal };
      const narrow = matchMedia('(max-width: 749px)');
      const menus = [...dialog.querySelectorAll('[data-mega-menu]')];
      const update = () => {
        const active = menus.find(menu => menu.open);
        dialog.style.setProperty('--submenu-header-height', dialog.querySelector('.mobile-menu__header').offsetHeight + 'px');
        dialog.querySelectorAll('.mobile-menu__body > nav > .navigation-list > li').forEach(item => { item.inert = Boolean(active && narrow.matches && !item.contains(active)); });
        dialog.querySelector('.mobile-menu__footer').inert = Boolean(active && narrow.matches);
        menus.forEach(menu => { menu.querySelector('summary').tabIndex = menu.open && narrow.matches ? -1 : 0; });
      };
      menus.forEach(menu => {
        menu.addEventListener('toggle', () => {
          if (menu.open) {
            menus.forEach(other => { if (other !== menu) other.open = false; });
            update(); menu.querySelector('[data-submenu-back]')?.focus();
          } else update();
        }, opts);
        menu.querySelector('[data-submenu-back]')?.addEventListener('click', () => { menu.open = false; update(); menu.querySelector('summary').focus(); }, opts);
      });
      dialog.addEventListener('close', () => { menus.forEach(menu => { menu.open = false; }); update(); }, opts);
      narrow.addEventListener('change', update, opts);
      const resize = new ResizeObserver(update); resize.observe(dialog.querySelector('.mobile-menu__header'));
      controllers.set(dialog, () => { resize.disconnect(); controller.abort(); });
    });
    scope.querySelectorAll('[data-header-tooltip]').forEach(trigger => {
      if (controllers.has(trigger)) return;
      const controller = new AbortController(), opts = {signal: controller.signal};
      const dismiss = () => { trigger.dataset.tooltipDismissed = ''; };
      const reset = () => { delete trigger.dataset.tooltipDismissed; };
      trigger.addEventListener('pointerleave', reset, opts);
      trigger.addEventListener('focusout', reset, opts);
      trigger.addEventListener('click', dismiss, opts);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && getComputedStyle(trigger.querySelector('.site-header__tooltip')).visibility === 'visible') dismiss();
      }, opts);
      controllers.set(trigger, () => controller.abort());
    });
    scope.querySelectorAll('[data-category-tabs]').forEach(section => {
      if (controllers.has(section)) return;
      const controller = new AbortController();
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const select = tab => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1;
          document.getElementById(item.getAttribute('aria-controls')).hidden = !active;
        });
        document.dispatchEvent(new CustomEvent('may-london:products-rendered'));
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab), { signal: controller.signal });
        tab.addEventListener('keydown', event => {
          const next = { ArrowRight: (index+1)%tabs.length, ArrowLeft: (index+tabs.length-1)%tabs.length, Home: 0, End: tabs.length-1 }[event.key];
          if (next === undefined) return;
          event.preventDefault(); tabs[next].focus(); select(tabs[next]);
        }, { signal: controller.signal });
      });
      controllers.set(section, () => controller.abort());
    });
    scope.querySelectorAll('[data-mega-menu]').forEach(menu => {
      if (controllers.has(menu)) return;
      const controller = new AbortController();
      const opts = { signal: controller.signal };
      let closeTimer;
      const desktop = () => !menu.closest('[data-mobile-menu]') && finePointer.matches;
      const close = () => { clearTimeout(closeTimer); menu.open = false; };
      menu.addEventListener('pointerenter', () => {
        if (!desktop()) return;
        clearTimeout(closeTimer);
        document.querySelectorAll('.site-header__nav [data-mega-menu]').forEach(other => { if (other !== menu) other.open = false; });
        menu.open = true;
      }, opts);
      menu.addEventListener('pointerleave', () => {
        if (desktop() && !menu.contains(document.activeElement)) closeTimer = setTimeout(close, 180);
      }, opts);
      menu.addEventListener('focusout', event => { if (!menu.contains(event.relatedTarget)) close(); }, opts);
      menu.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault(); event.stopPropagation(); close();
        menu.querySelector('summary').focus();
      }, opts);
      controllers.set(menu, () => { clearTimeout(closeTimer); controller.abort(); });
    });
    scope.querySelectorAll('[data-laptop]').forEach(laptop => {
      if (controllers.has(laptop)) return;
      const controller = new AbortController();
      const button = laptop.querySelector('[data-laptop-toggle]');
      let paused = reducedMotion.matches;
      let visible = true;
      const update = () => {
        laptop.dataset.paused = String(paused || document.hidden || reducedMotion.matches);
        laptop.dataset.visible = String(visible);
        button.disabled = reducedMotion.matches;
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.title = button.getAttribute('aria-label');
        button.querySelector('[data-laptop-play]').hidden = !paused;
        button.querySelector('[data-laptop-pause]').hidden = paused;
      };
      button.addEventListener('click', () => { paused = !paused; update(); }, { signal: controller.signal });
      document.addEventListener('visibilitychange', update, { signal: controller.signal });
      reducedMotion.addEventListener('change', update, { signal: controller.signal });
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; update(); });
      observer.observe(laptop); update();
      controllers.set(laptop, () => { observer.disconnect(); controller.abort(); });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((dispose, element) => {
      if (event.target.contains(element)) { dispose(); controllers.delete(element); }
    });
  });
})();
